import React, { Component } from 'react';

class Modal extends Component {
    constructor(props) {
        
        super(props);
        this.state = { 
            isOpen:true,
         }
    }
    setCategory = value => () => {
        const state = this.state;
        state.isOpen = value;
        this.setState(state);
        };
    render() { 
        return ( 
            <>
            {this.state.isOpen ? 
                  <div className="modal">
                  <div class="modal-content" >
                  <h1>{this.props.date}</h1>
                      <div className="col-2">

                          <div> <p>{this.props.lat}</p></div>
                          <div> <p>{this.props.lon}</p></div>
                      </div>
                          <div className="right">
                              <button onClick={this.setCategory(false)} className="secondary">Close</button>
                            </div>
                      <div className="col-3">
                      </div>
                  </div>
              </div>
            : null }
            </>
         );
    }
}
 
export default Modal;